module.exports = __webpack_public_path__ + "img/bg-salon.e943e9d5.png";